export const templatesFr = {
    title: "Gabarits d'impression",
    create: "Créer un gabarit d'impression",
    columns: {
        name: 'Nom',
        type: 'Type',
        version: 'Version',
        fileName: 'Nom du fichier',
        lastEditor: 'Dernier éditeur',
        checksum: 'Checksum'
    },
    types: {
        rfid_chip: 'Puce RFID',
        parcel_label: 'Étiquette colis',
        end_roll_label: 'Étiquette fin de rouleau'
    },
    dialog: {
        createTitle: "Créer un gabarit d'impression",
        editTitle: "Modifier le gabarit d'impression",
        deleteTitle: "Supprimer le gabarit d'impression",
        deleteContent: "Êtes-vous sûr de vouloir supprimer le gabarit d'impression « {name} » ?"
    },
    form: {
        name: 'Nom',
        type: 'Type',
        filePlaceholder: 'Glissez-déposez un fichier ici ou cliquez pour parcourir',
        fileOptional: 'Glissez-déposez un nouveau fichier pour remplacer l\'actuel (facultatif)',
        browseFile: 'Parcourir'
    },
    actions: {
        download: 'Télécharger',
        edit: 'Modifier',
        delete: 'Supprimer'
    },
    success: {
        created: "Gabarit d'impression créé avec succès",
        updated: "Gabarit d'impression mis à jour avec succès",
        deleted: "Gabarit d'impression supprimé avec succès"
    }
}
